export default __webpack_public_path__ + "static/media/Logo_JetOS_04_horizontal.651d5cf7.png";